module.exports = __webpack_public_path__ + "img/ranking2.b8666676.png";